import { clsx } from 'clsx'
import { Image } from 'component/Image'
import { env } from 'config/environment'
import { observer } from 'mobx-react-lite'
import { ReactElement } from 'react'
import LogoAtelierSvg from './logo-atelier.svg'
import LogoDresscodeSvg from './logo-dresscode.svg'
import LogoShowoffSvg from './logo-showoff.svg'
import css from './ShopLogo.module.scss'

type Props = {
  logo: string | undefined
  link: string | undefined
  compact?: boolean
}

function renderLogo(logo: string | undefined): ReactElement {
  const atelier = env.domain === 'atelier'
  const dresscode = env.domain === 'dresscode'

  if (logo) return <Image src={logo} />
  if (atelier) return <LogoAtelierSvg />
  if (dresscode) return <LogoDresscodeSvg />
  return <LogoShowoffSvg />
}

export const ShopLogo = observer(({ logo, link, compact }: Props) => {
  const className = clsx(css.logo, compact && css.compact)

  return <a className={className} href={link || undefined} target="_blank">
    {renderLogo(logo)}
  </a>
})
